<div class="ds-transfers-marquee-main">
  <span *ngFor="let item of sliderItems" class="marquee-item">


    <!-- Free Cancellation Driver -->
     <span *ngIf="item.freeCancellation" class="eva-3-driver -info -j1" [ngClass]="{'-benefits': item.freeCancellation}" (click)="!isDesktop ? show() : ''"
           #tooltipTarget tooltip
           [tooltip-enabled]="isDesktop"
           tooltip-id="free-driver-tooltip"
           tooltip-title="{{'transfer-marquee.freeCancellation.tooltip.title' | translate}}"
           tooltip-content="{{'transfer-marquee.freeCancellation.tooltip.description' | translate}}"
           tooltip-color="WHITE"
           tooltip-position="CENTER_TOP"
           tooltip-class="eva-3-body-2"
           click-stop-propagation>
        <span class="driver-text">{{item.text | translate}}</span>
    </span>

    <span *ngIf="isDefaultDriver(item)" class="eva-3-driver -info -j4">
      <span class="driver-text">{{item.text | translate}}</span>
    </span>

    <!--  Driver de Previaje/MinTur  -->
    <span *ngIf="item.mintur" class="marquee-item">
      <span class="eva-3-driver -mintur -j1">
        <span class="driver-text">{{item.text | translate}}</span>
      </span>
    </span>

    <span *ngIf="item.freeWifi" class="eva-3-driver -info -j1">
      <span class="driver-text">{{item.text | translate}}</span>
    </span>

    <span *ngIf="item.familiesRecommended" class="eva-3-driver -info -j1">
      <span class="driver-text">{{item.text | translate}}</span>
    </span>

    <span *ngIf="item.direct" class="eva-3-driver -info -j1">
      <span class="driver-text">{{item.text | translate}}</span>
    </span>

    <!--  Most Purchased Driver (AB test S-TRANSFERS-BEST-SELLER)  -->
    <span *ngIf="item.mostPurchased" class="eva-3-driver -new">
      <i class="driver-icon eva-3-icon-star-filled"></i>
      <span class="driver-text">{{item.text | translate}}</span>
    </span>
  </span>
</div>


<div *ngIf="!isDesktop" class="eva-3-modal -eva-3-hide-large -sm -title-lg" CloseModalClick [modal]="this" [ngClass]="{'-show-modal' : isOpen}">
  <div class="modal-header">
    <i class="modal-close eva-3-icon-close" (click)="close()"></i>
    <div class="modal-title-container">
      <p class="modal-title eva-3-h4">{{ marqueeModalTitle}}</p>
    </div>
  </div>
  <div class="modal-content">
    <p class="eva-3-body-2">{{ marqueeModalDescription}}</p>
  </div>
</div>